import AppHeader from "../layouts/AppHeader";
import AppFooter from "../layouts/AppFooter";

const routes = [
    {
        path: '/',
        name: 'Dashboard',
        components: {
            header: AppHeader,
            default: () => import('../views/Dashboard'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
        meta: {guestOnly: true}
    },
    {
        path: '/extra-facilities',
        name: 'ExtraFacilities',
        components: {
            header: AppHeader,
            default: () => import('../views/ExtraFacilities'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/niche-categories',
        name: 'NicheCategories',
        components: {
            header: AppHeader,
            default: () => import('../views/NicheCategories.vue'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/sites',
        name: 'Sites',
        components: {
            header: AppHeader,
            default: () => import('../views/Sites.vue'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/orders',
        name: 'Orders',
        components: {
            header: AppHeader,
            default: () => import('../views/Orders.vue'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/users',
        name: 'Users',
        components: {
            header: AppHeader,
            default: () => import('../views/Users.vue'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/profile',
        name: 'Profile',
        components: {
            header: AppHeader,
            default: () => import('../views/Profile.vue'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/system-settings',
        name: 'SystemSettings',
        components: {
            header: AppHeader,
            default: () => import('../views/SystemSettings'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/methods',
        name: 'Methods',
        components: {
            header: AppHeader,
            default: () => import('../views/Methods'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/payments',
        name: 'Payments',
        components: {
            header: AppHeader,
            default: () => import('../views/ManualCredits'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/resellers',
        name: 'Resellers',
        components: {
            header: AppHeader,
            default: () => import('../views/Resellers'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/reports',
        name: 'Reports',
        components: {
            header: AppHeader,
            default: () => import('../views/reports/Reports'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/payment-settings',
        name: 'PaymentSettings',
        components: {
            header: AppHeader,
            default: () => import('../views/PaymentSettings'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/invoice',
        name: 'Invoice',
        components: {
            header: AppHeader,
            default: () => import('../views/Invoice'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/invoices',
        name: 'Invoices',
        components: {
            header: AppHeader,
            default: () => import('../views/Invoices'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/invoice-migration',
        name: 'InvoicesMigration',
        components: {
            header: AppHeader,
            default: () => import('../views/InvoiceMigration'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/edit-invoice-migration/:id',
        name: 'EditInvoicesMigration',
        components: {
            header: AppHeader,
            default: () => import('../views/EditInvoice'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/admins',
        name: 'Admins',
        components: {
            header: AppHeader,
            default: () => import('../views/Admins'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/mail-templates',
        name: 'MailTemplates',
        components: {
            header: AppHeader,
            default: () => import('../views/MailTemplates'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: () => import('../views/Login.vue'),
        meta: {guestOnly: true}
    },
    {
        path: '/reports/invoices',
        name: 'InvoicesReport',
        components: {
            header: AppHeader,
            default: () => import('../views/reports/InvoiceReport'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/reports/sites',
        name: 'SitesReport',
        components: {
            header: AppHeader,
            default: () => import('../views/reports/SiteReport'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/reports/sites-summary-report',
        name: 'SitesSummaryReport',
        components: {
            header: AppHeader,
            default: () => import('../views/reports/SitesSummaryReport'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/reports/sales-by-sites',
        name: 'SalesBySites',
        components: {
            header: AppHeader,
            default: () => import('../views/reports/SalesBySitesReport'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/live-link-replacement/:id',
        name: 'LiveLinkReplacement',
        components: {
            header: AppHeader,
            default: () => import('../views/LiveLinkReplacement'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/broken-links',
        name: 'BrokenLinks',
        components: {
            header: AppHeader,
            default: () => import('../views/BrokenLinks'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/background-jobs',
        name: 'BackgroundJobs',
        components: {
            header: AppHeader,
            default: () => import('../views/BackgroundJobs'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/wp-access-control',
        name: 'WPAccessControl',
        components: {
            header: AppHeader,
            default: () => import('../views/WPAccess'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/logs',
        name: 'Logs',
        components: {
            header: AppHeader,
            default: () => import('../views/Logs'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/error-logs',
        name: 'ErrorLogs',
        components: {
            header: AppHeader,
            default: () => import('../views/ErrorLogs'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/task-scheduler',
        name: 'TaskScheduler',
        components: {
            header: AppHeader,
            default: () => import('../views/TaskScheduler'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/profile/google-sheet-sync',
        name: 'GoogleSheetSync',
        components: {
            header: AppHeader,
            default: () => import('../views/GoogleSheetSync'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/profile/filter-mailbox',
        name: 'FilterMailbox',
        components: {
            header: AppHeader,
            default: () => import('../views/FilterMailbox'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    /*{
        path: '/special-clients',
        name: 'SpecialClient',
        components: {
            header: AppHeader,
            default: () => import('../views/clients/SpecialClients'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/agency-clients',
        name: 'AgencyClient',
        components: {
            header: AppHeader,
            default: () => import('../views/clients/AgencyClients'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },*/
    {
        path: '/mail-box',
        name: 'MailBox',
        components: {
            header: AppHeader,
            default: () => import('../views/mail-box/MailBox'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/site-logs',
        name: 'SiteLogs',
        components: {
            header: AppHeader,
            default: () => import('../views/logs/SiteLogs'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/newsletter-logs',
        name: 'NewsletterLogs',
        components: {
            header: AppHeader,
            default: () => import('../views/logs/NewsLetterLogs'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/queued-job-logs',
        name: 'QueuedJobLogs',
        components: {
            header: AppHeader,
            default: () => import('../views/logs/QueuedJobLogs'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/failed-queued-logs',
        name: 'FailedQueuedLogs',
        components: {
            header: AppHeader,
            default: () => import('../views/logs/FailedQueuedLogs'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/merged-invoice',
        name: 'MergedInvoice',
        components: {
            header: AppHeader,
            default: () => import('../views/MergedInvoice'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/merged-invoice-list',
        name: 'MergedInvoiceList',
        components: {
            header: AppHeader,
            default: () => import('../views/MergedInvoiceList'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/edit-merged-invoice/:id',
        name: 'EditMergedInvoice',
        components: {
            header: AppHeader,
            default: () => import('../views/MergedInvoice'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/google-analytics',
        name: 'GoogleAnalytics',
        components: {
            header: AppHeader,
            default: () => import('../views/GoogleAnalytics'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/site-owners',
        name: 'SiteOwners',
        components: {
            header: AppHeader,
            default: () => import('../views/SiteOwners'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/site-ownerships',
        name: 'SiteOwnerships',
        components: {
            header: AppHeader,
            default: () => import('../views/SiteOwnership'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/reports/client-summary',
        name: 'ClientSummary',
        components: {
            header: AppHeader,
            default: () => import('../views/reports/ClientSummaryReport'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/alfa-coins-currency',
        name: 'AlfaCoinsCurrency',
        components: {
            header: AppHeader,
            default: () => import('../views/Cryptocurrency'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/client-list',
        name: 'ClientList',
        components: {
            header: AppHeader,
            default: () => import('../views/Clients'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    },
    {
        path: '/client-types',
        name: 'ClientTypes',
        components: {
            header: AppHeader,
            default: () => import('../views/ClientType'),
            footer: AppFooter
        },
        meta: {authOnly: true}
    }
]

export default routes;
